<template>
  <el-drawer class="drawer fs-credit-drawer" :withHeader="false" :show-close="false" :destroy-on-close="true" :visible.sync="is_open" size="90%"
    direction="btt">
    <el-row class="fs-site" v-if="page == 1">
      <el-col class="fs-entry-header text-center">
        <h1 class="text-title--large">{{ $t('drawer.credit.list.header') }}</h1>
      </el-col>
      <el-col class="fs-credit-content">
        <el-row>
          <el-col class="fs-credit-list" v-if="UserCardList.length > 0">
            <li @click="goToCardDetail(list)" v-for="(list, index) in UserCardList" :key="index">
              <el-row>
                <!-- {{ UserCardList }} -->
                <el-col :span="4">
                  <img :src="'https://images.foodstory.co/' + list.img">
                </el-col>
                <el-col :span="16">
                  <label class="text-heading3">{{ $t('drawer.credit.list.tail') }} {{ list.number }}</label>
                </el-col>
                <el-col :span="4" class="text-right">
                  <i class="fas fa-chevron-right"></i>
                </el-col>
              </el-row>
            </li>
          </el-col>
          <el-col v-else>
            <el-row class="fs-list-none text-center">
              <el-col>
                <img width="100" src="@/assets/icons/card/carddemo.png">
              </el-col>
              <el-col>
                <h2 class="text-heading--med">{{ $t('drawer.credit.list.title') }}</h2>
              </el-col>
              <el-col>
                <label class="text-subtitle">{{ $t('drawer.credit.list.description1') }}</label><br>
                <label class="text-subtitle">{{ $t('drawer.credit.list.description2') }}</label>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <DrawerCreditDetail v-if="page == 2" :cardDetail="cardDetail" @back_page="back_page"/>
  </el-drawer>
</template>
<script>
/* eslint-disable no-unused-vars */
/* eslint-disable vue/no-unused-components */
import DrawerCreditDetail from '@/components/creditcard/DrawerCreditDetail'
import fullButton from '@/components/element/fullButton'
import Mixins from '@/utils/mixins'

export default {
  name: 'DrawerListCreditCard',
  props: {
    is_credit_detail:{
      default: false
    }
  },
  components: {
    DrawerCreditDetail,
    fullButton
  },
  mixins: [Mixins],
  data() {
    return {
      is_open: true,
      page: 1,
      cardDetail: null
    }
  },
  mounted () {
    this.$store.dispatch('getUserCardList')
  },
  methods: {
    goToCardDetail (list) {
      this.cardDetail = list
      this.page = 2
    },
    toggle_credit_detail () {
      this.is_credit_detail = !this.is_credit_detail;
    },
    back_page(value) {
      if (value == 'delete') {
        this.$store.dispatch('getUserCardList')
        setTimeout(() => {
          this.page = 1
        }, 1000)
      } else {
        this.page = 1
      }
    }
  },
  computed: {
    UserCardList () {
      return this.$store.getters.UserCardList
    }
  },
  watch:{
    UserCardList () {},
    is_open (value) {
      if (!value) {
        this.$emit('toggle_creditcard', true)
      }
    }
  }
}

</script>




// WEBPACK FOOTER //
// src/components/creditcard/DrawerListCreditCard.vue